<template>
  <b-card v-if="data" class="earnings-card">
    <b-row>
      <b-col cols="6">
        <b-card-title class="mb-1">
          <img src="@/assets/icons/sweep-svgrepo-com.svg" width="30" class="my-svg-alternatex" alt="" />

          {{ $t('Sweep statistics') }}
        </b-card-title>
        <div class="font-small-2">
          <feather-icon icon="CircleIcon" size="16" :class="'text-primary'" />
          {{ $t('Planned Distance') }} : {{ data.PlannedDistance }}
        </div>

        <div class="font-small-2">
          <feather-icon icon="CircleIcon" size="16" :class="'text-primary'" />
          {{ $t('Served Distance') }} : {{ data.ServedDistance }}
        </div>


        <div class="font-small-2">
          <feather-icon icon="CircleIcon" size="16" :class="'text-primary'" />
          {{ $t('Sweepers') }} : {{ data.Sweepers }}
        </div>
        <!-- <b-card-text class="text-muted font-small-2">
          <span class="font-weight-bolder">68.2%</span><span> more earnings than last month.</span>
        </b-card-text> -->
      </b-col>
      <b-col cols="6" class="pull-right">


        <b-card-text class="mb-50">
          {{ $t('PlansProgress') }}: {{ data.PlansProgress }}
        </b-card-text>
        <!-- chart -->
        <b-progress :value=data.PlansProgress max="100" height="12px" />



      </b-col>
    </b-row>
    <b-row>
   <hr width="100%"/>
      <b-col cols="12" v-if="data.Contracts!=undefined">
        <services-chart :widgetLabels="{planned:'service count planed',served:'service count served',complection:'service count complection'}"  
                    :barSeries="data.Contracts.series" title='Rian Data'
                    :labels_data="data.Contracts.categories" :other_data="[]" 
                    :listData="data.Contracts.lists" 
                    />
      </b-col>
    </b-row>
  </b-card>
</template>

<script>

import {
  BCard, BRow, BCol, BCardTitle, BCardText, BProgress
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import vSelect from 'vue-select'
import ServicesChart from '@/views/dashboard/services/ServicesChart'
const $earningsStrokeColor2 = '#28c76f66'
const $earningsStrokeColor3 = '#28c76f33'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BProgress,
    BCardTitle,
    BCardText,
    VueApexCharts,
    vSelect,
    ServicesChart

  },
  props: {

    data: {
      type: Object,
      default: () => { },
    },
    chartsData: {
      type: Array,
      default: () => { }

    }
  },
  computed: {


  },

  data() {
    return {
      earningsChart: {
        chartOptions: {
          chart: {
            type: 'pie',
            toolbar: {
              show: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: { show: false },
          comparedResult: [2, -3, 8],
          labels: [this.$t('Served')],
          stroke: { width: 0 },
          // colors: [$earningsStrokeColor2, $earningsStrokeColor3, $themeColors.success],
          colors: [$themeColors.primary, $themeColors.warning, $themeColors.danger],
          grid: {
            padding: {
              right: -20,
              bottom: -8,
              left: -20,
            },
          },
          plotOptions: {
            pie: {
              startAngle: -10,
              donut: {
                labels: {
                  show: true,
                  name: {
                    offsetY: 15,
                  },
                  value: {
                    offsetY: -15,
                    formatter(val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}%`
                    },
                  },
                  total: {
                    show: true,
                    offsetY: 15,
                    label: this.$t('Served'),
                    formatter(w) {
                      return `${w.globals.seriesTotals[0]}%`;
                    },
                  },
                },
              },
            },
          },
          responsive: [
            {
              breakpoint: 1325,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 1200,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
            {
              breakpoint: 1045,
              options: {
                chart: {
                  height: 100,
                },
              },
            },
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 120,
                },
              },
            },
          ],
        },
      },
    }
  },
}
</script>
<style scoped>
.my-svg-alternate {
  display: none;
}

/* .no-svg .my-svg-alternate {
  display: block;
  width: 100px;
  height: 100px;
  background-image:url('../../assets/icons/sweep-svgrepo-com.svg')
   
} */
</style>